import React, { useState, useEffect, useMemo, useRef } from "react";
import { Markup } from "interweave";

import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

import { Box, IconButton, Paper } from "@mui/material";

import LoaderAnimation from "pages/LoaderAnimation";

export default function MessageCarousel ({ messages, hasInitializationError }) {
  const [isAdvancing, setIsAdvancing] = useState(true);
  
  const messageLength = useMemo(() => {
    return messages ? messages.length : 0;
  },[messages]);

  const messagesLengthRef = useRef(messageLength);
  messagesLengthRef.current = messageLength;

  const [activeStep, setActiveStep] = useState(0);
  const activeStepRef = useRef(activeStep);
  activeStepRef.current = activeStep;
  const [timeoutId, setTimeoutId] = useState(null);

  const handleNext = () => {
    setActiveStep((activeStepRef.current + 1) % messagesLengthRef.current);
  };

  const handleBack = () => {
    setActiveStep((activeStepRef.current + messagesLengthRef.current - 1) % messagesLengthRef.current);
  };

  const toggleAutoAdvance = () => {
    setIsAdvancing((prevIsAdvancing) => !prevIsAdvancing);
  }

  useEffect(() => {
    setActiveStep(0);
  }, [messages]);

  useEffect(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    if (isAdvancing) {
      let id = setTimeout(handleNext, 5000);
      setTimeoutId(id);
    }
  },[activeStep, isAdvancing])

  return (
    <Box>
      {hasInitializationError ? <h4 className="text-center mb-4">Error Loading Messages.</h4>
        : messages === null ? <LoaderAnimation /> 
        : messages.length === 0 ? <h5 className="text-center mb-4">No Messages to display.</h5>
        : 
        <>
            <MobileStepper
                variant="dots"
                steps={messages.length}
                position="static"
                activeStep={activeStep}
                nextButton={
                    <Box>
                    <IconButton size="small" onClick={toggleAutoAdvance} color="primary" sx={{ border: "1px solid", marginRight: "10px" }}>
                        {isAdvancing ? <PauseIcon /> : <PlayArrowIcon />}
                    </IconButton>

                    <IconButton size="small" onClick={handleNext} color="primary">
                        <KeyboardArrowRight />
                    </IconButton>
                    </Box>
                }
                backButton={
                    <IconButton size="small" onClick={handleBack} color="primary">
                        <KeyboardArrowLeft />
                    </IconButton>
                }
            />

            
            <Paper className="d-flex justify-content-center" sx={{ overflowY: "auto", height: "calc(100vh - 158px)" }}>
                <Box>
                    <Markup content={messages[activeStep]} />
                </Box>
            </Paper>
        </>}
    </Box>
  );
}
